var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_598_8237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 1.0625H8.5C8.21829 1.06278 7.94821 1.17481 7.74901 1.37401C7.54981 1.57321 7.43778 1.84329 7.4375 2.125V7.4375H2.125C1.84329 7.43778 1.57321 7.54981 1.37401 7.74901C1.17481 7.94821 1.06278 8.21829 1.0625 8.5V15.9375H15.9375V2.125C15.9372 1.84331 15.8251 1.57324 15.6259 1.37406C15.4268 1.17487 15.1567 1.06282 14.875 1.0625ZM4.78125 14.875V11.1562H6.90625V14.875H4.78125ZM14.875 14.875H7.96875V10.625C7.96875 10.4841 7.91278 10.349 7.81315 10.2493C7.71352 10.1497 7.5784 10.0938 7.4375 10.0938H4.25C4.1091 10.0938 3.97398 10.1497 3.87435 10.2493C3.77472 10.349 3.71875 10.4841 3.71875 10.625V14.875H2.125V8.5H8.5V2.125H14.875V14.875Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 4.25H9.5625V5.3125H10.625V4.25Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 4.25H12.75V5.3125H13.8125V4.25Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 7.4375H9.5625V8.5H10.625V7.4375Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 7.4375H12.75V8.5H13.8125V7.4375Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 10.6248H9.5625V11.6873H10.625V10.6248Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 10.6248H12.75V11.6873H13.8125V10.6248Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 6.375H3.71875C3.71958 5.67077 3.9997 4.99563 4.49766 4.49766C4.99563 3.9997 5.67077 3.71958 6.375 3.71875V4.78125C5.95245 4.78171 5.54735 4.94978 5.24856 5.24856C4.94978 5.54735 4.78171 5.95245 4.78125 6.375Z",
    fill: "#797C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.125 6.375H1.0625C1.0641 4.96653 1.62433 3.61621 2.62027 2.62027C3.61621 1.62433 4.96653 1.0641 6.375 1.0625V2.125C5.24823 2.12629 4.16797 2.57448 3.37122 3.37122C2.57448 4.16797 2.12629 5.24823 2.125 6.375Z",
    fill: "#797C7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_598_8237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorIcon);
export default __webpack_public_path__ + "static/media/SectorIcon.865348648a3800a735290ab2ece1883b.svg";
export { ForwardRef as ReactComponent };